var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFrankenstein = function SvgFrankenstein(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M22.2 1.125a1.07 1.07 0 0 0-.8-.375H2.605a1.07 1.07 0 0 0-.807.375 1.24 1.24 0 0 0-.3.887l1.076 15.174a1 1 0 0 0 .4.72l1.912 1.468a1 1 0 0 1 .4.761l.059 2.118a1.07 1.07 0 0 0 1.1 1h11.109a1.07 1.07 0 0 0 1.105-1l.059-2.118a1 1 0 0 1 .4-.761l2.282-1.749 1.1-15.613a1.24 1.24 0 0 0-.3-.887"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.75 14.286a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m6.75-.036a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m-5.25 4.5H15M1.5 2.25l2.649 2.761a1.21 1.21 0 0 0 1.441 0l1.932-1.467a1.21 1.21 0 0 1 1.441 0L10.9 5.011a1.21 1.21 0 0 0 1.44 0l1.935-1.469a1.21 1.21 0 0 1 1.439 0l1.941 1.47a1.21 1.21 0 0 0 1.439 0l3.356-3.441M1.996 9h20.013M6 8.25v1.5m6-1.5v1.5m6-1.5v1.5M5.285 20.25H1.5m0-1.098v2.049m17.215-.951H22.5m0-1.098v2.049"
  })));
};
export default SvgFrankenstein;